import React, { useState, useEffect } from 'react';
import PaginationTypeSwitcher from './PaginationTypeSwitcher';

const surahToPage = {
    1: 1, 2: 2, 3: 50, 4: 77, 5: 106, 6: 128, 7: 151, 8: 177, 9: 187, 10: 208,
    11: 221, 12: 235, 13: 249, 14: 255, 15: 262, 16: 267, 17: 282, 18: 293, 19: 305, 20: 312,
    21: 322, 22: 332, 23: 342, 24: 350, 25: 359, 26: 367, 27: 377, 28: 385, 29: 396, 30: 404,
    31: 411, 32: 415, 33: 418, 34: 428, 35: 434, 36: 440, 37: 446, 38: 453, 39: 458, 40: 467,
    41: 477, 42: 483, 43: 489, 44: 496, 45: 499, 46: 502, 47: 507, 48: 511, 49: 515, 50: 518,
    51: 520, 52: 523, 53: 526, 54: 528, 55: 531, 56: 534, 57: 537, 58: 542, 59: 545, 60: 549,
    61: 551, 62: 553, 63: 554, 64: 556, 65: 558, 66: 560, 67: 562, 68: 564, 69: 566, 70: 568,
    71: 570, 72: 572, 73: 574, 74: 575, 75: 577, 76: 578, 77: 580, 78: 582, 79: 583, 80: 585,
    81: 586, 82: 587, 83: 588, 84: 589, 85: 590, 86: 591, 87: 591, 88: 592, 89: 593, 90: 594,
    91: 595, 92: 596, 93: 597, 94: 597, 95: 598, 96: 598, 97: 599, 98: 599, 99: 600, 100: 600,
    101: 601, 102: 601, 103: 602, 104: 602, 105: 602, 106: 603, 107: 603, 108: 603, 109: 604,
    110: 604, 111: 604, 112: 604, 113: 604, 114: 604
};

const surahOptions = [
    { value: 1, label: "سُورَةُ ٱلْفَاتِحَةِ" },
    { value: 2, label: "سُورَةُ البَقَرَةِ" },
    { value: 3, label: "سُورَةُ آلِ عِمۡرَانَ" },
    { value: 4, label: "سُورَةُ النِّسَاءِ" },
    { value: 5, label: "سُورَةُ المَائـِدَةِ" },
    { value: 6, label: "سُورَةُ الأَنۡعَامِ" },
    { value: 7, label: "سُورَةُ الأَعۡرَافِ" },
    { value: 8, label: "سُورَةُ الأَنفَالِ" },
    { value: 9, label: "سُورَةُ التَّوۡبَةِ" },
    { value: 10, label: "سُورَةُ يُونُسَ" },
    { value: 11, label: "سُورَةُ هُودٍ" },
    { value: 12, label: "سُورَةُ يُوسُفَ" },
    { value: 13, label: "سُورَةُ الرَّعۡدِ" },
    { value: 14, label: "سُورَةُ إِبۡرَاهِيمَ" },
    { value: 15, label: "سُورَةُ الحِجۡرِ" },
    { value: 16, label: "سُورَةُ النَّحۡلِ" },
    { value: 17, label: "سُورَةُ الإِسۡرَاءِ" },
    { value: 18, label: "سُورَةُ الكَهۡفِ" },
    { value: 19, label: "سُورَةُ مَرۡيَمَ" },
    { value: 20, label: "سُورَةُ طه" },
    { value: 21, label: "سُورَةُ الأَنبِيَاءِ" },
    { value: 22, label: "سُورَةُ الحَجِّ" },
    { value: 23, label: "سُورَةُ المُؤۡمِنُونَ" },
    { value: 24, label: "سُورَةُ النُّورِ" },
    { value: 25, label: "سُورَةُ الفُرۡقَانِ" },
    { value: 26, label: "سُورَةُ الشُّعَرَاءِ" },
    { value: 27, label: "سُورَةُ النَّمۡلِ" },
    { value: 28, label: "سُورَةُ القَصَصِ" },
    { value: 29, label: "سُورَةُ العَنكَبُوتِ" },
    { value: 30, label: "سُورَةُ الرُّومِ" },
    { value: 31, label: "سُورَةُ لُقۡمَانَ" },
    { value: 32, label: "سُورَةُ السَّجۡدَةِ" },
    { value: 33, label: "سُورَةُ الأَحۡزَابِ" },
    { value: 34, label: "سُورَةُ سَبَإٍ" },
    { value: 35, label: "سُورَةُ فَاطِرٍ" },
    { value: 36, label: "سُورَةُ يسٓ" },
    { value: 37, label: "سُورَةُ الصَّافَّاتِ" },
    { value: 38, label: "سُورَةُ صٓ" },
    { value: 39, label: "سُورَةُ الزُّمَرِ" },
    { value: 40, label: "سُورَةُ غَافِرٍ" },
    { value: 41, label: "سُورَةُ فُصِّلَتۡ" },
    { value: 42, label: "سُورَةُ الشُّورَىٰ" },
    { value: 43, label: "سُورَةُ الزُّخۡرُفِ" },
    { value: 44, label: "سُورَةُ الدُّخَانِ" },
    { value: 45, label: "سُورَةُ الجَاثِيَةِ" },
    { value: 46, label: "سُورَةُ الأَحۡقَافِ" },
    { value: 47, label: "سُورَةُ مُحَمَّدٍ" },
    { value: 48, label: "سُورَةُ الفَتۡحِ" },
    { value: 49, label: "سُورَةُ الحُجُرَاتِ" },
    { value: 50, label: "سُورَةُ قٓ" },
    { value: 51, label: "سُورَةُ الذَّارِيَاتِ" },
    { value: 52, label: "سُورَةُ الطُّورِ" },
    { value: 53, label: "سُورَةُ النَّجۡمِ" },
    { value: 54, label: "سُورَةُ القَمَرِ" },
    { value: 55, label: "سُورَةُ الرَّحۡمَٰن" },
    { value: 56, label: "سُورَةُ الوَاقِعَةِ" },
    { value: 57, label: "سُورَةُ الحَدِيدِ" },
    { value: 58, label: "سُورَةُ المُجَادلَةِ" },
    { value: 59, label: "سُورَةُ الحَشۡرِ" },
    { value: 60, label: "سُورَةُ المُمۡتَحنَةِ" },
    { value: 61, label: "سُورَةُ الصَّفِّ" },
    { value: 62, label: "سُورَةُ الجُمُعَةِ" },
    { value: 63, label: "سُورَةُ المُنَافِقُونَ" },
    { value: 64, label: "سُورَةُ التَّغَابُنِ" },
    { value: 65, label: "سُورَةُ الطَّلَاقِ" },
    { value: 66, label: "سُورَةُ التَّحۡرِيمِ" },
    { value: 67, label: "سُورَةُ المُلۡكِ" },
    { value: 68, label: "سُورَةُ القَلَمِ" },
    { value: 69, label: "سُورَةُ الحَاقَّةِ" },
    { value: 70, label: "سُورَةُ المَعَارِجِ" },
    { value: 71, label: "سُورَةُ نُوحٍ" },
    { value: 72, label: "سُورَةُ الجِنِّ" },
    { value: 73, label: "سُورَةُ المُزَّمِّلِ" },
    { value: 74, label: "سُورَةُ المُدَّثِّرِ" },
    { value: 75, label: "سُورَةُ القِيَامَةِ" },
    { value: 76, label: "سُورَةُ الإِنسَانِ" },
    { value: 77, label: "سُورَةُ المُرۡسَلَاتِ" },
    { value: 78, label: "سُورَةُ النَّبَإِ" },
    { value: 79, label: "سُورَةُ النَّازِعَاتِ" },
    { value: 80, label: "سُورَةُ عَبَسَ" },
    { value: 81, label: "سُورَةُ التَّكۡوِيرِ" },
    { value: 82, label: "سُورَةُ الانفِطَارِ" },
    { value: 83, label: "سُورَةُ المُطَفِّفِينَ" },
    { value: 84, label: "سُورَةُ الانشِقَاقِ" },
    { value: 85, label: "سُورَةُ البُرُوجِ" },
    { value: 86, label: "سُورَةُ الطَّارِقِ" },
    { value: 87, label: "سُورَةُ الأَعۡلَىٰ" },
    { value: 88, label: "سُورَةُ الغَاشِيَةِ" },
    { value: 89, label: "سُورَةُ الفَجۡرِ" },
    { value: 90, label: "سُورَةُ البَلَدِ" },
    { value: 91, label: "سُورَةُ الشَّمۡسِ" },
    { value: 92, label: "سُورَةُ اللَّيۡلِ" },
    { value: 93, label: "سُورَةُ الضُّحَىٰ" },
    { value: 94, label: "سُورَةُ الشَّرۡحِ" },
    { value: 95, label: "سُورَةُ التِّينِ" },
    { value: 96, label: "سُورَةُ العَلَقِ" },
    { value: 97, label: "سُورَةُ القَدۡرِ" },
    { value: 98, label: "سُورَةُ البَيِّنَةِ" },
    { value: 99, label: "سُورَةُ الزَّلۡزَلَةِ" },
    { value: 100, label: "سُورَةُ العَادِيَاتِ" },
    { value: 101, label: "سُورَةُ القَارِعَةِ" },
    { value: 102, label: "سُورَةُ التَّكَاثُرِ" },
    { value: 103, label: "سُورَةُ العَصۡرِ" },
    { value: 104, label: "سُورَةُ الهُمَزَةِ" },
    { value: 105, label: "سُورَةُ الفِيلِ" },
    { value: 106, label: "سُورَةُ قُرَيۡشٍ" },
    { value: 107, label: "سُورَةُ المَاعُونِ" },
    { value: 108, label: "سُورَةُ الكَوۡثَرِ" },
    { value: 109, label: "سُورَةُ الكَافِرُونَ" },
    { value: 110, label: "سُورَةُ النَّصۡرِ" },
    { value: 111, label: "سُورَةُ المَسَدِ" },
    { value: 112, label: "سُورَةُ الإِخۡلَاصِ" },
    { value: 113, label: "سُورَةُ الفَلَقِ" },
    { value: 114, label: "سُورَةُ النَّاسِ" },
];
const pagesOptions = Array.from({ length: 604 }, (_, i) => ({
    value: i + 1,
    label: `الصفحة ${i + 1}`
}));

export default function Pagination({
    currentPage,
    changePage,
    totalPages,
    setCurrentPage,
    onFontChange,
    paginationType,
    setPaginationType,
    displayStartAyah,
    setDisplayStartAyah,
    displayEndAyah,
    setDisplayEndAyah,
    ayahsCount,
    metaData,
    displayMode,
    setDisplayMode,
    currentFavoriteId,
    setCurrentFavoriteId,
    loadFavoriteById
}) {
    //   const getCurrentValue = () => {
    //     // if (paginationType === "surah") {
    //     //   // Find surah number from current page
    //     //   return Object.entries(surahToPage).reduce((closest, [surah, page]) => {
    //     //     return page <= currentPage ? surah : closest;
    //     //   }, 1);
    //     // }
    //     return currentPage;
    //   };

    const handleSelectionChange = (e) => {
        const value = parseInt(e.target.value);
        if (paginationType === "page") {
            setCurrentPage(value);
        } else {
            setCurrentPage(value);
            setDisplayStartAyah(null);
            setDisplayEndAyah(null);
        }
    };
    const nextPrevButtons = (delta) => {
        if (displayMode === 'favorite') {
            if (favorites.length === 0) return;
            const idx = favorites.findIndex(f => f.id === currentFavoriteId);
            let nextIdx = idx + delta;
            if (nextIdx < 0) nextIdx = favorites.length - 1;
            if (nextIdx >= favorites.length) nextIdx = 0;
            loadFavoriteById(favorites[nextIdx].id);
        } else {
            const newPage = parseInt(currentPage) + delta;
            setCurrentPage(newPage);
            setDisplayStartAyah(null);
            setDisplayEndAyah(null);
        }
    }

    //   const currentValue =currentPage;
    const name = displayMode === "favorite" ? "المفضلة" : (paginationType === "page" ? "الصفحة" : "السورة");

    const [favorites, setFavorites] = useState([]);
    const [feedbackMsg, setFeedbackMsg] = useState('');

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem('quran_favorites') || '[]');
        setFavorites(saved);
    }, []);

    const handleDisplayModeChange = (mode) => {
        setDisplayMode(mode);
        if (mode !== 'favorite') {
            setPaginationType(mode);
        }
    };

    const addToFavorite = () => {
        const itemLabel = paginationType === "surah"
            ? `${surahOptions.find(o => o.value == currentPage)?.label} ${ayahsCount > 0 ? `(${displayStartAyah || 1} - ${displayEndAyah || ayahsCount})` : ''}`
            : `الصفحة ${currentPage}`;

        const exists = favorites.find(f =>
            f.paginationType === paginationType &&
            f.currentPage === currentPage &&
            f.displayStartAyah === displayStartAyah &&
            f.displayEndAyah === displayEndAyah
        );
        if (exists) {
            alert('هذه المفضلة محفوظة مسبقاً');
            return;
        }

        const newItem = {
            id: Date.now(),
            paginationType,
            currentPage,
            displayStartAyah,
            displayEndAyah,
            label: itemLabel
        };

        const newFavorites = [...favorites, newItem];
        setFavorites(newFavorites);
        localStorage.setItem('quran_favorites', JSON.stringify(newFavorites));

        if (displayMode === 'favorite') {
            loadFavoriteById(newItem.id);
        }

        setFeedbackMsg('تمت الإضافة بنجاح!');
        setTimeout(() => setFeedbackMsg(''), 2000);
    };

    const handleFavoriteSelect = (e) => {
        const favId = parseInt(e.target.value);
        if (!favId) return;
        loadFavoriteById(favId);
    };

    const removeCurrentFavorite = () => {
        const confirmDel = window.confirm('هل تريد مسح هذه المفضلة؟');
        if (!confirmDel) return;

        const newFavorites = favorites.filter(f => f.id !== currentFavoriteId);
        setFavorites(newFavorites);
        localStorage.setItem('quran_favorites', JSON.stringify(newFavorites));

        if (newFavorites.length > 0) {
            loadFavoriteById(newFavorites[0].id);
        } else {
            setCurrentFavoriteId(null);
            setDisplayMode('surah');
        }
    };

    return (
        <div className="pagination">
            <div className='paginationNumbers'>
                <button onClick={() => nextPrevButtons(-1)}>{name} السابقة</button>
                <span id="pageNumber">{currentPage}</span>
                <button onClick={() => nextPrevButtons(1)}>{name} التالية</button>
            </div>
            <PaginationTypeSwitcher
                displayMode={displayMode}
                setDisplayMode={handleDisplayModeChange}
            />



            <div>
                {displayMode === "favorite" ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center' }}>
                        {favorites.length > 0 ? (
                            <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                <select onChange={handleFavoriteSelect} value={currentFavoriteId || ""} className="selection-dropdown" style={{ width: 'auto', textAlign: 'right' }}>
                                    <option value="" disabled>المفضلة...</option>
                                    {favorites.map(fav => (
                                        <option key={fav.id} value={fav.id}>{fav.label}</option>
                                    ))}
                                </select>
                                <button
                                    onClick={removeCurrentFavorite}
                                    style={{ fontSize: '12px', padding: '3px 6px', background: '#dc3545', color: '#fff', border: 'none', borderRadius: '3px' }}
                                    title="مسح المفضلة المحددة"
                                >
                                    حذف
                                </button>
                            </div>
                        ) : (
                            <div style={{ fontSize: '14px', color: '#666' }}>لا يوجد مفضلة محفوظة</div>
                        )}
                    </div>
                ) : displayMode === "surah" ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <select
                            id="surahSelector"
                            onChange={handleSelectionChange}
                            value={currentPage}
                            className="selection-dropdown"
                        >
                            {(metaData?.surahs?.references ? metaData.surahs.references.map(s => ({ value: s.number, label: s.name })) : surahOptions).map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        {(() => {
                            const activeSurahMeta = metaData?.surahs?.references?.find(s => s.number === currentPage);
                            const dynamicAyahsCount = paginationType === "surah" && activeSurahMeta ? activeSurahMeta.numberOfAyahs : ayahsCount;

                            if (dynamicAyahsCount > 0) {
                                return (
                                    <div className="form-group range-selector" style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                                        <div>
                                            <label>من: </label>
                                            <select
                                                value={displayStartAyah || 1}
                                                onChange={(e) => {
                                                    const val = parseInt(e.target.value);
                                                    setDisplayStartAyah(val);
                                                    if (displayEndAyah && val > displayEndAyah) setDisplayEndAyah(val);
                                                }}
                                                className="selection-dropdown"
                                                style={{ width: '67px' }}
                                            >
                                                {Array.from({ length: dynamicAyahsCount }, (_, i) => i + 1).map(num => (
                                                    <option key={`start-${num}`} value={num}>{num}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            <label>إلى: </label>
                                            <select
                                                value={displayEndAyah || dynamicAyahsCount}
                                                onChange={(e) => {
                                                    const val = parseInt(e.target.value);
                                                    setDisplayEndAyah(val);
                                                    if (displayStartAyah && val < displayStartAyah) {
                                                        setDisplayStartAyah(val);
                                                    } else if (!displayStartAyah && val < 1) {
                                                        setDisplayStartAyah(val);
                                                    }
                                                }}
                                                className="selection-dropdown"
                                                style={{ width: '67px' }}
                                            >
                                                {Array.from({ length: dynamicAyahsCount }, (_, i) => i + 1).map(num => (
                                                    <option key={`end-${num}`} value={num}>{num}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                );
                            }
                            return null;
                        })()}
                    </div>
                ) : (
                    <select
                        id="pageSelector"
                        onChange={handleSelectionChange}
                        value={currentPage}
                        className="selection-dropdown"
                    >
                        {pagesOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                )}
            </div>
            <div className="favorites-container" style={{ display: 'flex', width: '100%', flexDirection: 'column', gap: '5px', alignItems: 'center', marginTop: '3px', marginBottom: '3px' }}>
                {displayMode !== 'favorite' && (
                    <button onClick={addToFavorite} style={{ fontSize: '12px', padding: '5px 10px', transition: 'background-color 0.3s' }}>إضافة للمفضلة ⭐️</button>
                )}
                {feedbackMsg && <div style={{ fontSize: '12px', color: '#28a745', fontWeight: 'bold', marginTop: '2px', animation: 'fadeIn 0.3s' }}>{feedbackMsg}</div>}
            </div>
        </div>
    );
}